import { observer } from "mobx-react-lite";
import { useNavigate } from "react-router-dom";
import useOpenSelectedItem from "../../hooks/useOpenSelectedItem";
import CompanyIcon from "../icons/CompanyIcon";
import styles from "../InfoWithIconAndNavigation.module.css";
import CompanyInfo, { ICompanyInfoProps } from "./CompanyInfo";

function CompanyInfoWithIconAndNavigation({ id, name, className, onClick, index }: ICompanyInfoWithIconAndNavigationProps) {
    const navigate = useNavigate();

    const click = () => {
        onClick && onClick();
        navigate(`/companies/${id}`);
    };

    useOpenSelectedItem(index, click);

    return (
        <div className={[styles.container, className].join(" ")} onClick={click}>
            <CompanyIcon color="#25479A" className={styles.icon} />
            <CompanyInfo
                id={id}
                name={name}
            />
        </div>
    );
}

interface ICompanyInfoWithIconAndNavigationProps extends ICompanyInfoProps {
    index?: number;
}

export default observer(CompanyInfoWithIconAndNavigation)